import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { EmptyCheckOutHistoryComponent } from './empty-check-out-history/empty-check-out-history.component';
import { EmptyCheckOutDetailsComponent } from './empty-check-out-details/empty-check-out-details.component';

type TabKey = 'details' | 'history';

@Component({
    selector: 'app-empty-check-out',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        EmptyCheckOutDetailsComponent,
        EmptyCheckOutHistoryComponent,
    ],
    templateUrl: './empty-check-out.component.html',
})
export class EmptyCheckOutComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.EmptyCheckOutDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.EmptyCheckOutHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.EmptyCheckOutDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.EmptyCheckOutHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
